import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
import useTable from "../../../../components/useTable";
//UI
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { Checkbox, Input, Select } from "../../../../ui/inputs/Input";
import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import { formatMoneda, validaMonto } from "../../../../util/varios";

const headCells = [
  {
    id: "codint",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Integrante",
    textAlign: "center",
  },
  {
    id: "nomint",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "left",
  },
  {
    id: "moncons",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Valor de la Constante",
    textAlign: "right",
  },
];

const handleInputMontoChange = (event) => {
  validaMonto(event);
  if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
    event.target.value = '0,00'
  }
  if (event.which >= 37 && event.which <= 40) {
    event.preventDefault();
  }

  // Devuelve el número formateado
  let e = event.target.value.replace(/\D/g, "")
    .replace(/([0-9])([0-9]{2})$/, '$1.$2')
    .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

  return formatMoneda(e)
};

// Componente para editar/consultar valor de constante por integrante
const ModalEditValorConstante = ({ show, onHide, data, readonly, onSave }) => {
  const [valor, setValor] = useState(data?.moncons || '0,00');
  const txtValor = useRef();

  useEffect(() => {
    if (data) {
      setValor(data.moncons || '0,00');
    }
  }, [data]);

  const handleSave = () => {
    let valorNumerico = txtValor.current.value.replace(/\./g, "").replace(",", ".");

    if (onSave && data) {
      onSave(data.codint, valorNumerico);
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="azulGradiant" closeButton>
        <Modal.Title>{readonly ? 'Consultar' : 'Editar'} Valor de Constante</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row px-0 mx-auto col-md-12">
          <div className="input-group input-group-sm mb-1 col-md-7">
            <span className="input-group-text" id="inputGroup-sizing-sm">Código Integrante</span>
            <input type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" value={data?.codint || ''} disabled />
          </div>

          <div className="mb-1 col-md-5"></div>

          <div className="input-group input-group-sm mb-1 col-md-12">
            <span className="input-group-text" id="inputGroup-sizing-sm">Nombre</span>
            <input type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" value={data?.nomint || ''} disabled />
          </div>

          <div className="mb-1 col-md-7"></div>

          <div className="input-group input-group-sm mb-1 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">Valor</span>
            <input type="text" className="form-control text-end" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" ref={txtValor} defaultValue={valor}
              onKeyUp={handleInputMontoChange}
              disabled={readonly} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!readonly && (
          <button className="btn btn-success" onClick={handleSave}>
            Guardar
          </button>
        )}
        <button className="btn btn-danger" onClick={onHide}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

// Componente para cambiar valores masivos
const ModalCambiarValoresMasivos = ({ show, onHide, onSave, codigoConstante }) => {
  const [tipoCambio, setTipoCambio] = useState('1');
  const [valorReferencia, setValorReferencia] = useState('');
  const [codigoConstanteRef, setCodigoConstanteRef] = useState('');
  const [constantes, setConstantes] = useState([]);
  const [loading, setLoading] = useState(false);
  var op = require('../../../../modulos/datos');

  useEffect(() => {
    if (show) {
      cargarConstantes();
    }
  }, [show]);

  const cargarConstantes = async () => {
    let token = localStorage.getItem('jwtToken');
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');

    setLoading(true);
    try {
      let nomtab = `nomi${codigoNomina}.constantes`;
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=codcons,nomcons&nomtab=${nomtab}&condi=1=1&orden=codcons`;
      const response = await axios.get(endpoint, { headers: { "x-access-token": `${token}` } });
      setConstantes(response.data || []);
    } catch (error) {
      console.error('Error cargando constantes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    let valor = null;
    if (tipoCambio === '1') {
      if (!codigoConstanteRef) {
        alert('Seleccione una constante');
        return;
      }
      valor = { tipo: 'constante', codigo: codigoConstanteRef };
    } else if (tipoCambio === '2') {
      if (!valorReferencia) {
        alert('Ingrese un porcentaje');
        return;
      }
      valor = { tipo: 'porcentaje', porcentaje: parseFloat(valorReferencia) };
    } else if (tipoCambio === '3') {
      if (!valorReferencia) {
        alert('Ingrese un monto');
        return;
      }
      valor = { tipo: 'monto', monto: parseFloat(valorReferencia.replace(/\./g, '').replace(',', '.')) };
    }
    if (onSave) onSave(valor);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Cambiar Valores de Constantes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-1">
          <label className="form-label">Seleccione el tipo de cambio:</label>
          <select className="form-select" value={tipoCambio} onChange={(e) => setTipoCambio(e.target.value)}>
            <option value="1">Copiar valor de otra constante</option>
            <option value="2">Aplicar porcentaje</option>
            <option value="3">Establecer monto fijo</option>
          </select>
        </div>

        {tipoCambio === '1' && (
          <div className="mb-1">
            <label className="form-label">Seleccione la constante:</label>
            <select
              className="form-select"
              value={codigoConstanteRef}
              onChange={(e) => setCodigoConstanteRef(e.target.value)}
              disabled={loading}
            >
              <option value="">Seleccione...</option>
              {constantes.map(c => (
                <option key={c.codcons} value={c.codcons}>
                  {c.codcons} - {c.nomcons}
                </option>
              ))}
            </select>
          </div>
        )}

        {tipoCambio === '2' && (
          <div className="mb-1">
            <label className="form-label">Porcentaje a aplicar (%):</label>
            <input
              type="text"
              className="form-control"
              value={valorReferencia}
              onChange={(e) => setValorReferencia(e.target.value)}
              placeholder="Ej: 10 para aumentar 10%"
            />
            <small className="text-muted">Use números positivos o negativos (ej: -5 para disminuir 5%)</small>
          </div>
        )}

        {tipoCambio === '3' && (
          <div className="mb-1">
            <label className="form-label">Nuevo monto:</label>
            <input
              type="text"
              className="form-control"
              value={valorReferencia}
              onChange={(e) => setValorReferencia(e.target.value)}
              placeholder="0,00"
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary" onClick={handleSave}>
          Aplicar Cambios
        </button>
        <button className="btn btn-danger" onClick={onHide}>
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default function Constantes({ show, setShow, setTabla, conexion, codigoNomina, usuario, codigoConstante, operacion }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  // Datos del formulario principal
  const [formData, setFormData] = useState({
    codcons: '',
    nomcons: '',
    unicons: '',
    valcons: '0,00',
    tope: '0,00',
    fijo: false,
    mosval: false
  });

  // Datos de la tabla de valores por integrante
  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; } });
  const [selectedIntegrante, setSelectedIntegrante] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showCambioMasivoModal, setShowCambioMasivoModal] = useState(false);

  // Estado para el buscador GENERAL
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const searchInputRef = useRef(null);

  const { TblContainer, TblHead, recordsAfterPagingAndSorting , TblPagination } = useTable(tableData, headCells, filterFn);

  // Debounce para la búsqueda (espera 300ms después de que el usuario deja de teclear)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Filtrar datos cuando cambia el término de búsqueda - BÚSQUEDA GENERAL en todos los campos
  useEffect(() => {
    if (!debouncedSearchTerm.trim()) {
      setFilterFn({ fn: items => items });
      return;
    }

    const searchLower = debouncedSearchTerm.toLowerCase().trim();

    setFilterFn({
      fn: items => {
        return items.filter(item => {
          // Buscar en TODOS los campos de la tabla
          return (
            item.codint?.toString().toLowerCase().includes(searchLower) ||
            item.nomint?.toLowerCase().includes(searchLower) ||
            item.moncons?.toString().toLowerCase().includes(searchLower)
          );
        });
      }
    });
  }, [debouncedSearchTerm]);

  // Limpiar búsqueda
  const clearSearch = () => {
    setSearchTerm('');
    setDebouncedSearchTerm('');
    setFilterFn({ fn: items => items });
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  // Cargar datos cuando se abre el modal
  useEffect(() => {
    if (show && codigoConstante && operacion !== 1) {
      cargarConstante(codigoConstante);
    } else if (show && operacion === 1) {
      // Limpiar formulario para nueva constante
      setFormData({
        codcons: '',
        nomcons: '',
        unicons: '',
        valcons: '0,00',
        tope: '0,00',
        fijo: false,
        mosval: false
      });
      setTableData([]);
      setSelectedIntegrante(null);
      // Limpiar búsqueda
      clearSearch();
    }
  }, [show, codigoConstante, operacion]);

  const cargarConstante = async (codigo) => {
    setActivate(true);
    try {
      let nomtab = `nomi${codigoNomina}.constantes`;
      let condi = `codcons = '${codigo}'`;
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=${nomtab}&condi=${condi}&orden=codcons`;

      const response = await axios.get(endpoint, { headers: { "x-access-token": `${token}` } });

      if (response.data && response.data.length > 0) {
        const data = response.data[0];
        setFormData({
          codcons: data.codcons,
          nomcons: data.nomcons,
          unicons: data.unicons,
          valcons: formatNumber(data.valcons),
          tope: formatNumber(data.tope),
          fijo: data.fijo === 't' || data.fijo === true,
          mosval: data.mosval === 't' || data.mosval === true
        });

        // Cargar valores por integrante
        await cargarValoresIntegrante(codigo);
      }
    } catch (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || error.message, icono: 'error' });
    } finally {
      setActivate(false);
    }
  };

  const cargarValoresIntegrante = async (codigo) => {
    try {
      let campos = 'ci.codint,i.nomint,ci.moncons,ci.valcons'
      let nomtab = ` nomi${codigoNomina}.constantesinteg ci
        INNER JOIN nomi${codigoNomina}.integrantes i ON i.codint = ci.codint`;
      let condi = `ci.codcons = '${codigo}'`;
      let orden = 'ci.codint';
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

      const response = await axios.get(endpoint,
        { headers: { "x-access-token": `${token}` } }
      );

      if (response.data) {
        const formattedData = response.data.map(item => ({
          ...item,
          moncons: formatNumber(item.moncons)
        }));
        setTableData(formattedData);
      }
    } catch (error) {
      console.error('Error cargando valores:', error);
      setTableData([]);
    }
  };

  const formatNumber = (value) => {
    if (!value && value !== 0) return '0,00';
    const num = parseFloat(value);
    if (isNaN(num)) return '0,00';
    return num.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const parseNumber = (value) => {
    if (!value) return 0;
    return parseFloat(value.replace(/\./g, '').replace(',', '.'));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleNumberChange = (field, value) => {
    const numericValue = parseNumber(value);
    setFormData(prev => ({ ...prev, [field]: formatNumber(numericValue) }));
  };

  const handleCheckboxChange = (field, checked) => {
    setFormData(prev => ({ ...prev, [field]: checked }));
  };

  const validarCampos = () => {
    if (!formData.codcons.trim()) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El código de la constante no debe estar en blanco', icono: 'error' });
      return false;
    }
    if (formData.codcons === '0000') {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El código de la constante no debe ser cero', icono: 'error' });
      return false;
    }
    if (!formData.nomcons.trim()) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El nombre de la constante no debe estar en blanco', icono: 'error' });
      return false;
    }
    if (!formData.unicons.trim()) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'La unidad de la constante no debe estar en blanco', icono: 'error' });
      return false;
    }
    return true;
  };

  const guardarConstante = async () => {
    if (operacion === 3) {
      setMensajesino({
        mostrar: true,
        titulo: 'Confirmación',
        texto: '¿Está seguro de eliminar este registro?',
        icono: 'question'
      });
      return;
    }

    if (!validarCampos()) return;

    setActivate(true);
    try {
      const cValor = parseNumber(formData.valcons);
      const cTope = parseNumber(formData.tope);

      const requestData = {
        operacion: operacion,
        ccodcons: formData.codcons,
        cnomcons: formData.nomcons.toUpperCase(),
        cunicons: formData.unicons.toUpperCase(),
        bfijo: formData.fijo,
        ntope: cTope,
        nvalcons: cValor,
        nmoncons: cValor,
        bmosval: formData.mosval,
        esquema1: `nomi${codigoNomina}`
      };

      const endpoint = `${op.conexion}/api/nomina/constante_act`;
      const response = await axios.post(endpoint, requestData, { headers: { "x-access-token": `${token}` } });

      console.log('Respuesta del servidor:', response.data);

    } catch (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response?.data?.message || error.message, icono: 'error' });
    } finally {
      setActivate(false);
    }
  };

  const guardarValorIntegrante = async (codint, nuevoValor) => {
    setActivate(true);
    try {
      const valorNumerico = nuevoValor;
      const requestData = {
        operacion: 2,
        ccodint: codint,
        ccodcons: formData.codcons,
        cvalcons: valorNumerico,
        esquema: `nomi${codigoNomina}`
      };

      const endpoint = `${op.conexion}/api/nomina/constantesinteg_act`;
      const response = await axios.post(endpoint, requestData, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        await cargarValoresIntegrante(formData.codcons);
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Valor actualizado correctamente',
          icono: 'exito'
        });
        setTimeout(() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' }), 2000);
      } else {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: response.data?.message || 'Error al guardar el valor',
          icono: 'error'
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const cambiarValoresMasivos = async (cambioData) => {
    setActivate(true);
    try {
      const requestData = {
        tipo: cambioData.tipo,
        codigoConstante: formData.codcons,
        codigoNomina: codigoNomina,
        ...cambioData
      };

      const endpoint = `${op.conexion}/api/constantes/cambiarValoresMasivos`;
      const response = await axios.post(endpoint, requestData, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.data && response.data.success) {
        await cargarValoresIntegrante(formData.codcons);
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Valores actualizados correctamente',
          icono: 'success'
        });
        setTimeout(() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' }), 2000);
      } else {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: response.data?.message || 'Error al actualizar los valores',
          icono: 'error'
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
    } finally {
      setActivate(false);
    }
  };

  const handleConfirmarEliminacion = async () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    await guardarConstante();
  };

  const salir = () => {
    setShow(false);
    if (setTabla) setTabla();
  };

  const isEditable = operacion === 1 || operacion === 2;
  const isDeleteMode = operacion === 3;

  // Manejar selección de fila en la tabla
  const handleRowSelect = (item) => {
    setSelectedIntegrante(item);
  };

  return (
    <>
      <style jsx>{`
        .table-row-hover:hover {
          background-color: #f5f5f5 !important;
          transition: background-color 0.2s ease;
          cursor: pointer;
        }
        .form-label-sm {
          font-size: 0.875rem;
        }
        .search-highlight {
          background-color: #fff3cd;
        }
      `}</style>

      <Modal size="lg" show={show} centered backdrop="static" keyboard={false} onHide={salir}>
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
          <h3 className="fw-bold m-0">
            {operacion === 1 ? 'Incluir' : operacion === 2 ? 'Editar' : operacion === 3 ? 'Eliminar' : 'Consultar'} Constante
          </h3>
          <a type="button" className="fw-bold text-light fs-6" onClick={salir} style={{ cursor: 'pointer' }}>
            Salir <i className="fa fa-times ms-2"></i>
          </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2">
          <ul className="nav mb-2" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link active bg-blue-100 text-light"
                id="constantes-tab"
                data-bs-toggle="tab"
                data-bs-target="#constantes-tab-pane"
                type="button"
                role="tab"
              >
                Constantes
              </button>
            </li>
            {operacion !== 1 ? <li className="nav-item" role="presentation">
              <button
                className="rounded nav-link bg-blue-200 text-light"
                id="valorConstantes-tab"
                data-bs-toggle="tab"
                data-bs-target="#valorConstantes-tab-pane"
                type="button"
                role="tab"
              >
                Valor de las Constantes
              </button>
            </li> : ''}
          </ul>
          <div className="tab-content" id="myTabContent">
            {/* Pestaña Constantes */}
            <div
              className="tab-pane fade show active"
              id="constantes-tab-pane"
              role="tabpanel"
            >
              <form onSubmit={(e) => e.preventDefault()} className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-4 m-0 mb-2 p-0">
                  <Input
                    label="Cod. Constantes:"
                    value={formData.codcons}
                    onChange={(e) => handleInputChange('codcons', e.target.value)}
                    disabled={!isEditable || isDeleteMode}
                    maxLength={4}
                  />
                </div>
                <div className="col-8 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Nombre:"
                    value={formData.nomcons}
                    onChange={(e) => handleInputChange('nomcons', e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-4 m-0 mb-2 p-0">
                  <Input
                    label="Unidad:"
                    value={formData.unicons}
                    onChange={(e) => handleInputChange('unicons', e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input
                    label="Valor:"
                    value={formData.valcons}
                    onChange={(e) => handleNumberChange('valcons', e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input
                    label="Tope:"
                    value={formData.tope}
                    onChange={(e) => handleNumberChange('tope', e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-auto m-0 p-0 d-flex gap-2">
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Fijo"
                      id="check-fijo"
                      checked={formData.fijo}
                      onChange={(e) => handleCheckboxChange('fijo', e.target.checked)}
                      disabled={!isEditable}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox
                      label="Mostrar valor de la constante"
                      id="check-mostrar"
                      checked={formData.mosval}
                      onChange={(e) => handleCheckboxChange('mosval', e.target.checked)}
                      disabled={!isEditable}
                    />
                  </div>
                </div>
              </form>
            </div>

            {/* Pestaña Valor de las Constantes - CON BUSCADOR GENERAL */}
            <div
              className="tab-pane fade"
              id="valorConstantes-tab-pane"
              role="tabpanel"
            >
              <div className="col-12 m-0 p-0">
                {/* Barra de búsqueda general */}
                <div className="col-md-12 row mx-auto px-0 mb-2">

                  <input
                    ref={searchInputRef}
                    type="text"
                    className="form-control form-control-sm rounded-pill border-table col-md-5"
                    placeholder="Buscar por código, nombre o valor..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    autoComplete="off"
                  />
                  <div className="col-md-8"></div>
                </div>

                {/* Tabla con contenedor responsive y scroll */}
                <div className="col-md-12 mx-auto row px-0" >
                  <div className="col mx-auto row px-0" >
                    <TblContainer>
                      <TblHead />
                      <tbody>
                        {tableData && tableData.length > 0 ? (
                          recordsAfterPagingAndSorting().length > 0 ? (
                            recordsAfterPagingAndSorting().map((item, index) => (
                              <tr
                                key={index}
                                onClick={() => handleRowSelect(item)}
                                style={{
                                  cursor: 'pointer',
                                  backgroundColor: selectedIntegrante?.codint === item.codint ? '#e3f2fd' : 'transparent'
                                }}
                                className="table-row-hover"
                              >
                                <td className='text-center'>{item.codint}</td>
                                <td className='text-start'>{item.nomint}</td>
                                <td className='text-end'>{item.moncons}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-4 text-muted">
                                <i className="fa fa-search fa-2x mb-2 d-block"></i>
                                No se encontraron resultados para <strong>"{debouncedSearchTerm}"</strong>
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center py-4 text-muted">
                              <i className="fa fa-inbox fa-2x mb-2 d-block"></i>
                              No hay datos registrados
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </TblContainer>
                  </div>
                 <div className="col-1 d-flex flex-column justify-content-center">

                    <InfoButton
                      icon="fa-eye m-0"
                      onClick={() => {
                        if (selectedIntegrante) {
                          setEditMode(false);
                          setShowEditModal(true);
                        }
                      }}
                      disabled={!selectedIntegrante}
                      title="Consultar valor"
                    />
                    <WarningButton
                      icon="fa-edit m-0"
                      onClick={() => {
                        if (selectedIntegrante && operacion === 2 && formData.valcons !== '0,00') {
                          setEditMode(true);
                          setShowEditModal(true);
                        }
                      }}
                      disabled={operacion !== 2 || formData.valcons === '0,00' || !selectedIntegrante}
                      title="Editar valor"
                    />
                  </div>
                </div>


              </div>
 {tableData && tableData.length > 0 && (
      <div className="col-12 mt-3">
        <TblPagination />
      </div>
    )}
              {/* Botón de cambio masivo */}
              {operacion === 2 && formData.valcons !== '0,00' && tableData.length > 0 && (
                <div className="col-12 m-0 p-0 d-flex justify-content-center mt-3">
                  <div className="col-auto m-0 p-0">
                    <PrimaryButton onClick={() => setShowCambioMasivoModal(true)}>
                      <i className="fa fa-exchange me-2"></i>
                      Cambiar Valores de Constantes
                    </PrimaryButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!isDeleteMode && <SuccessButton onClick={guardarConstante}>Aceptar</SuccessButton>}
          {isDeleteMode && <DangerButton onClick={guardarConstante}>Eliminar</DangerButton>}
          <DangerButton onClick={salir}>Cancelar</DangerButton>
        </Modal.Footer>
      </Modal>

      {/* Modales fuera del Modal principal */}
      <ModalEditValorConstante
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        data={selectedIntegrante || {}}
        readonly={!editMode}
        onSave={guardarValorIntegrante}
      />

      <ModalCambiarValoresMasivos
        show={showCambioMasivoModal}
        onHide={() => setShowCambioMasivoModal(false)}
        onSave={cambiarValoresMasivos}
        codigoConstante={formData.codcons}
      />

      <Dimmer active={activate} inverted />
      <Mensaje mensaje={mensaje} onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
        onHideSi={handleConfirmarEliminacion}
      />
    </>
  );
}